module.exports = __webpack_public_path__ + "img/wingDRiderLogo@1x.bb24a7af.png";